import { type ReactElement } from 'react';

import Button from '@/common/components/button/button.component';
import EmptyState from '@/common/components/empty-state/empty-state.component';
import createUrlUtility from '@/common/utils/create-url.utility';

interface ProductErrorStateProps {
  onBackToStore: () => void;
}

export default function ProductErrorState({
  onBackToStore,
}: ProductErrorStateProps): ReactElement {
  return (
    <>
      <EmptyState
        message="گشتیم نبود، نگرد نیست!"
        iconSrc={createUrlUtility({
          params: 'static/images/svg/404-page.svg',
        })}
      />
      <Button fixed type="black" onClick={onBackToStore}>
        بازگشت به فروشگاه
      </Button>
    </>
  );
}
